module.exports = __webpack_public_path__ + "static/img/10_1.ef26f129.jpg";